/**
 * Gets the value stored under the given key in document.cookie
 *
 * @param  {string} key The key of the cookie
 * @return {string} The value of the cookie
 *
 * @public
 * @author Alex Kasemir
 */
var readCookie = function readCookie(key) {
  var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
};
/** @component */


export default readCookie;